import React from "react";
import { useTranslation } from "react-i18next";
import RenderWrapper from "features/shared/components/renderWrapper/RenderWrapper";
import DynamicComponetWrapper from "features/shared/components/dynamicComponetWrapper/DynamicComponetWrapper";
import TopBarIcons from "./topBarIcons/TopBarIcons";

interface Props {}

const TopBarHeading = ({}: Props) => {
  // tanslations
  const { t } = useTranslation("shared\\components");

  return (
    <>
      <RenderWrapper isVisible={() => t("topBarHeading.heading") !== ""}>
        <div className="d-flex align-items-center ml-3"
          dangerouslySetInnerHTML={{
            __html: t("topBarHeading.heading"),
          }}
        />
      </RenderWrapper>
      <DynamicComponetWrapper 
        baseComponentName="TopBarIcons"
        defaultComponentRender={() => (
          <TopBarIcons />
        )}
      />
    </>
  );
};

export default TopBarHeading;
